import { formatDate, getNow, toApiYmd } from "../../utils/dateUtil"
import calcChildAges, { ChildAgeInfos } from "./calcAge"

export type FacilityAgeLimit = {
  isMinGrade?: boolean,
  isMaxGrade?: boolean,
  minAgeYear?: number | null,
  maxAgeYear?: number | null,
  minAgeMonth?: number | null,
  maxAgeMonth?: number | null,
  minAgeClass?: number | null,
  maxAgeClass?: number | null,
  beforeDay?: number | null
}

export type OutLimitAgeChilds = {
  name: string,
  isOver: boolean,
  isUnder: boolean
}

// 施設側にも同様のメソッドあり。
const isInAcceptAgeLimit = (facilityAgeLimit: FacilityAgeLimit, birthday: Date) => {
  if (facilityAgeLimit.minAgeYear == null && facilityAgeLimit.maxAgeYear == null) {
    return {
      isOver: false,
      isUnder: false
    }
  }

  const nowDate = getNow()
  const acceptDate = _getAcceptDate(facilityAgeLimit, nowDate)
  const minChildAgeInfos: ChildAgeInfos = calcChildAges(toApiYmd(birthday), acceptDate)

  // 上限は基準日が申込当日固定となるため。
  const nowDateYmd = formatDate(nowDate, 'yyyy-MM-dd')
  const maxChildAgeInfos: ChildAgeInfos = calcChildAges(toApiYmd(birthday), nowDateYmd)

  return {
    isUnder: _checkMin(minChildAgeInfos, facilityAgeLimit),
    isOver: _checkMax(maxChildAgeInfos, facilityAgeLimit)
  }
}

function _checkMin(childAgeInfos: ChildAgeInfos, facilityAgeLimit: FacilityAgeLimit) {
  if(facilityAgeLimit.isMinGrade) {
    if (childAgeInfos.childAgeClass == null || facilityAgeLimit.minAgeClass == null) {
      return false
    } 
    
    if (childAgeInfos.childAgeClass < facilityAgeLimit.minAgeClass) {
      return true
    }
  } else {
    if (childAgeInfos.childAgeYear == null || facilityAgeLimit.minAgeYear == null) {
      return false
    }

    if (childAgeInfos.childAgeYear < facilityAgeLimit.minAgeYear) {
      return true
    } else {
      if (childAgeInfos.childAgeMonth == null || facilityAgeLimit.minAgeMonth == null) {
        return false
      }

      if (facilityAgeLimit.minAgeMonth
        && childAgeInfos.childAgeYear === facilityAgeLimit.minAgeYear
        && childAgeInfos.childAgeMonth < facilityAgeLimit.minAgeMonth) {
        return true
      }
    }
  }

  return false
}

function _checkMax(childAgeInfos: ChildAgeInfos, facilityAgeLimit: FacilityAgeLimit) {
  if(facilityAgeLimit.isMaxGrade) {
    if (childAgeInfos.childAgeClass == null || facilityAgeLimit.maxAgeClass == null) {
      return false
    } 
    
    if (facilityAgeLimit.maxAgeClass < childAgeInfos.childAgeClass) {
      return true
    }
  } else {
    if (childAgeInfos.childAgeYear == null || facilityAgeLimit.maxAgeYear == null) {
      return false
    }

    if (facilityAgeLimit.maxAgeYear < childAgeInfos.childAgeYear) {
      return true
    } else {
      if (childAgeInfos.childAgeMonth == null || facilityAgeLimit.maxAgeMonth == null) {
        return false
      }

      if (facilityAgeLimit.maxAgeMonth
        && childAgeInfos.childAgeYear === facilityAgeLimit.maxAgeYear
        && facilityAgeLimit.maxAgeMonth < childAgeInfos.childAgeMonth) {
        return true
      }
    }
  }

  return false
}

/*
 施設の受入年齢になるX日前から申込可能にするための基準日算出用メソッド
 施設の受入年齢になるX日前 = 申込当日からX日後に施設の受入年齢になる
 であり、実装としては「申込当日からX日後に施設の受入年齢になる」の考えで実装している。
*/
function _getAcceptDate(facilityAgeLimit: FacilityAgeLimit, nowDate: Date) {
  
  let acceptDateString
  if (facilityAgeLimit.beforeDay != null) {
    const acceptDate = new Date(nowDate)
    acceptDate.setDate(acceptDate.getDate() + facilityAgeLimit.beforeDay)

    acceptDateString = formatDate(acceptDate, 'yyyy-MM-dd')
  } else {
    acceptDateString = formatDate(nowDate, 'yyyy-MM-dd')
  }
  return acceptDateString
}

export default isInAcceptAgeLimit